module.exports = __webpack_public_path__ + "img/mc-shuffle.1a20ee2a.svg";